import React from 'react';
import styled, { StylesProps } from '../../../lib/styles';
import Image from '../../../components/presentational/Image';

import mainImageStyles from './MainImage_styles';

export interface MainImageProps {
  bg_url: string;
  caption: string;
}

const MainImage = ({
  bg_url,
  caption,
  styles,
}: MainImageProps & StylesProps<typeof mainImageStyles>) => (
  <div>
    <div className={styles.imageContainer}>
      <Image
        src={bg_url}
        resizeWidth={720}
        aspect={[16, 9]}
        className={styles.image}
      />
    </div>

    <div className={styles.caption} dangerouslySetInnerHTML={{ __html: caption, }} />
  </div>
);

export default styled(mainImageStyles)(MainImage);
